import { render, staticRenderFns } from "./file-page.vue?vue&type=template&id=392654b4&"
import script from "./file-page.vue?vue&type=script&lang=ts&"
export * from "./file-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392654b4')) {
      api.createRecord('392654b4', component.options)
    } else {
      api.reload('392654b4', component.options)
    }
    module.hot.accept("./file-page.vue?vue&type=template&id=392654b4&", function () {
      api.rerender('392654b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/file/file-page.vue"
export default component.exports